import CircleIcon from '@portalterreno/react-ui-icons/CircleIcon';
import StarIcon from '@portalterreno/react-ui-icons/StarIcon';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { CampaignInfo } from '../../types';
import StyledSpan from './StyledSpan';

export type BadgeProps = CampaignInfo & {
  operation?: string;
  propertyType?: string;
};

const Badge: React.FC<BadgeProps> = ({
  operation = 'Venta',
  propertyType = 'Propiedad',
  campaignTextColor,
  campaignIconColor,
  campaignName,
  ...rest
}) => {
  const { t } = useTranslation('property');
  return (
    // TODO: Agregar terrainType para el badge en terrenos
    <StyledSpan
      textColor={campaignTextColor}
      iconColor={campaignIconColor}
      {...rest}
    >
      {(campaignName && <StarIcon />) || (operation && <CircleIcon />)}
      {campaignName || `${t(propertyType)} en ${operation}`}
    </StyledSpan>
  );
};

export default React.memo(Badge);
